import { NavBar } from '../../../../themes/components/Navbar';
import { Sidebar } from '../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { BuscaClientes } from '../../components/BuscaClientes';
import { TabelaListaClientes } from '../../components/TabelaListaClientes';

export const ConsultarClientes = () => {
    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-clientes">
                    <NavBar />
                    <span className="novo-pedido-title-form">Busca de Clientes</span>
                    <BuscaClientes />
                    <span className="novo-pedido-title-form">Lista de Clientes</span>
                    <TabelaListaClientes />
                </div>
            </div>
            <Toaster />
        </div>
    )
}